import assets from '@timelyapp/static-assets';
import AnimateLogo from 'images/apps_logo/animate.svg';
import AsanaLogo from 'images/apps_logo/asana.svg';
import AttestLogo from 'images/apps_logo/attest.png';
import AzureLogo from 'images/apps_logo/azure.svg';
import BasecampLogo from 'images/apps_logo/basecamp3.png';
import ClickupLogo from 'images/apps_logo/clickup.svg';
import DropboxLogo from 'images/apps_logo/dropbox.png';
import GitHubLogo from 'images/apps_logo/github.png';
import GmailLogo from 'images/apps_logo/gmail.png';
import GoogleAdsLogo from 'images/apps_logo/google_ads.png';
import GoogleCalendarLogo from 'images/apps_logo/google_calendar.svg';
import GoogleSheetsLogo from 'images/apps_logo/google_sheets.svg';
import GpsTrackerLogo from 'images/apps_logo/gps_tracker.png';
import HarvestLogo from 'images/apps_logo/harvest.svg';
import HubspotLogo from 'images/apps_logo/hubspot.png';
import LinkedinLogo from 'images/apps_logo/linkedin.png';
import MailchimpLogo from 'images/apps_logo/mailchimp.png';
import MakeLogo from 'images/apps_logo/make.png';
import MemoryLogo from 'images/apps_logo/memory.svg';
import MiroLogo from 'images/apps_logo/miro.png';
import MondayLogo from 'images/apps_logo/monday.svg';
import MovesAppLogo from 'images/apps_logo/moves_app.png';
import Office365Logo from 'images/apps_logo/office365.svg';
import OutlookLogo from 'images/apps_logo/outlook.svg';
import PhoneCallsLogo from 'images/apps_logo/phone_calls.png';
import PowerBiLogo from 'images/apps_logo/powerbi.svg';
import SalesforceLogo from 'images/apps_logo/salesforce.png';
import SapLogo from 'images/apps_logo/sap.png';
import SemrushLogo from 'images/apps_logo/semrush.png';
import TeamsLogo from 'images/apps_logo/teams.svg';
import TimelyLogo from 'images/apps_logo/timely.svg';
import TodoistLogo from 'images/apps_logo/todoist.png';
import TogglLogo from 'images/apps_logo/toggl.svg';
import TrelloLogo from 'images/apps_logo/trello.png';
import WunderlistLogo from 'images/apps_logo/wunderlist.png';
import YoutubeLogo from 'images/apps_logo/youtube.png';
import ZapierLogo from 'images/apps_logo/zapier.svg';
import ZoomLogo from 'images/apps_logo/zoom.png';
import {
  ASANA,
  ASANA_SYNC,
  AZURE_AD,
  BASECAMP,
  CLICKUP,
  GITHUB,
  GMAIL,
  GOOGLE_CALENDAR,
  GOOGLE_SHEETS,
  HARVEST,
  JIRA,
  LINUX,
  MAC,
  MAKE,
  MONDAY,
  MOVES_APP,
  OFFICE365,
  OUTLOOK_MAIL,
  PHONE_CALLS,
  TEAMS,
  TIMELY,
  TIMELY_GPS_TRACKER,
  TODOIST,
  TOGGL,
  TRELLO,
  WINDOWS,
  WUNDERLIST,
  ZAPIER,
  ZOOM,
} from './known-apps';

// TODO: This list probably isn't scalable as we add new integrations?
const HUBSPOT = 'hubspot';
const LINKEDIN = 'linkedin';
const MAILCHIMP = 'mailchimp';
const ATTEST = 'attest';
const GOOGLE_ADS = 'google_ads';
const YOUTUBE = 'youtube';
const SEMRUSH = 'semrush';
const DROPBOX = 'dropbox';
const MIRO = 'miro';
const ADOBE_ANIMATE = 'adobe_animate';
const SAP = 'sap';
const SALESFORCE = 'salesforce';
const POWERBI = 'powerbi';

export const appIcons: Partial<Record<string, string>> = {
  [ASANA]: AsanaLogo,
  [ASANA_SYNC]: AsanaLogo,
  [GITHUB]: GitHubLogo,
  [GMAIL]: GmailLogo,
  [GOOGLE_CALENDAR]: GoogleCalendarLogo,
  [TIMELY_GPS_TRACKER]: GpsTrackerLogo,
  [MAC]: MemoryLogo,
  [LINUX]: MemoryLogo,
  [MOVES_APP]: MovesAppLogo,
  [OFFICE365]: Office365Logo,
  [PHONE_CALLS]: PhoneCallsLogo,
  [TIMELY]: TimelyLogo,
  [TODOIST]: TodoistLogo,
  [TRELLO]: TrelloLogo,
  [WINDOWS]: MemoryLogo,
  [WUNDERLIST]: WunderlistLogo,
  [ZOOM]: ZoomLogo,
  [JIRA]: assets.icons['jira_128.png'],
  [TOGGL]: TogglLogo,
  [HARVEST]: HarvestLogo,
  [BASECAMP]: BasecampLogo,
  [CLICKUP]: ClickupLogo,
  [HUBSPOT]: HubspotLogo,
  [LINKEDIN]: LinkedinLogo,
  [MAILCHIMP]: MailchimpLogo,
  [ATTEST]: AttestLogo,
  [GOOGLE_ADS]: GoogleAdsLogo,
  [YOUTUBE]: YoutubeLogo,
  [SEMRUSH]: SemrushLogo,
  [DROPBOX]: DropboxLogo,
  [MIRO]: MiroLogo,
  [ADOBE_ANIMATE]: AnimateLogo,
  [SAP]: SapLogo,
  [SALESFORCE]: SalesforceLogo,
  [POWERBI]: PowerBiLogo,
  [TEAMS]: TeamsLogo,
  [ZAPIER]: ZapierLogo,
  [MAKE]: MakeLogo,
  [AZURE_AD]: AzureLogo,
  [OUTLOOK_MAIL]: OutlookLogo,
  [MONDAY]: MondayLogo,
  [GOOGLE_SHEETS]: GoogleSheetsLogo,
  // Note: Linear icon comes from TIC API (icon_url), not static assets
};
